import { render } from "./InfoPage.vue?vue&type=template&id=5bde1e4e&ts=true"
import script from "./InfoPage.vue?vue&type=script&lang=ts"
export * from "./InfoPage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__